angular
	.module 'App.Component'
	.component 'tablePagination',
		{
			templateUrl: '@component/table/table-pagination/table-pagination.view.html'
			controller: 'TablePaginationComponent'
			controllerAs: 'tablePagination'
			bindings:
				page: '<'
				pageSize: '<'
				count: '<?'
				itemsCount: '<?'
				onPageChange: '&'
				onPageSizeChange: '&'
		}

###
@param count
@param pageSize
@param onChange
###
class TablePaginationComponent extends AbstractController
	@registerController()

	pageSizes: [
		10
		25
		50
		100
	]

	$onChanges: (changesObj) ->
		@ensurePageSize() if changesObj.pageSize? && changesObj.pageSize.isFirstChange()
		@setPagesCount() if changesObj.pageSize? || changesObj.count?

		# If we do not have total count or current page items count, we can't operate
		if not @count? && not @itemsCount?
			throw new Error(@name + ': no page items count or total items count provided')

		@hasNextPage = (@pagesCount? && @page < @pagesCount) || (@itemsCount? && @itemsCount == @pageSize)
		@hasPreviousPage = @page > 1

	ensurePageSize: ->
		if not @pageSize? or !@pageSizes.includes(@pageSize)
			@pageSize = @pageSizes[0]
			@onPageSizeChange({pageSize: @pageSize})

	setPagesCount: ->
		if @count?
			@pagesCount = Math.ceil(@count / @pageSize) || 1
		else
			@pagesCount = null
